<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div class="overline mb-2 mt-3 ml-4">
        {{ $t("components.data.dataAlerts.alerts") }}
      </div>
    </v-col>

    <v-col
      v-for="alert in selectedAlerts"
      :key="alert.id"
      :cols="cols || 12"
      class="mb-2 alert-col"
    >
      <v-card
        flat
        tile
        :ripple="false"
        @click="$emit('toggle-sensor', alert.device_sensor.uuid)"
        :class="[
          'alert-card mr-3',
          {
            'alert-card--selected': isAlertSelected(alert.device_sensor.uuid),
          },
        ]"
        :style="getAlertColorStyle(alert.device_sensor.uuid)"
      >
        <v-list-item three-line>
          <v-list-item-content>
            <div v-if="alert.type" class="overline mb-2">
              {{ alert.type }}
            </div>
            <v-list-item-title class="subtitle-1 mb-1">
              {{ alert.device_sensor.sensor.display_name }}
            </v-list-item-title>
            <v-list-item-subtitle class="mb-4">
              {{ alert.message }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="mb-1">
              {{ getDate(alert.created) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>

    <v-col v-if="selectedAlerts.length === 0" cols="12">
      <div class="subtitle-1 mx-4 mb-4 mt-2">
        {{ $t("components.data.dataAlerts.noAlertsFoundForThisDateRange") }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    selectedAlerts: {
      type: Array,
      required: true,
      default: () => [],
    },
    sensorList: {
      type: Array,
      required: false,
      default: () => [],
    },
    cols: {
      type: Number,
      required: false,
      default: 12,
    },
  },
  methods: {
    getDate(item) {
      return this.$moment(item * 1000).format("Do MMM, h:mm");
    },
    getSensor(uuid) {
      return this.sensorList
        ? this.sensorList.find((s) => s.uuid === uuid)
        : null;
    },
    isAlertSelected(uuid) {
      const sensor = this.getSensor(uuid);
      return sensor && sensor.selected;
    },
    getAlertColorStyle(uuid) {
      const sensor = this.getSensor(uuid);
      if (sensor && sensor.selected) {
        return { "--sensor-color": sensor.color };
      }
      return {};
    },
  },
};
</script>

<style scoped>
.alert-card {
  cursor: pointer;
  transition: all 0.2s ease;
  border-right: 0.375rem solid transparent;
}

.alert-card--selected {
  border-right-color: var(--sensor-color);
}

.alert-col {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  padding-top: 8px;
  margin-top: 0;
}

.col-12.alert-col:nth-child(2) {
  border-top: none;
  padding-top: 0;
}

.col-6.alert-col:nth-child(-n + 3) {
  border-top: none;
  padding-top: 0;
}
</style>
